<template>
  <div class="flex justify-center">
    <div class="py-10 lg:w-6/12 md:w-8/12 w-full ">
      <d-message v-if="genericError" type="error" class="w-full mb-3">
        {{ genericError }}
      </d-message>

      <h1 class="font-bold">
        Login
      </h1>

      <form ref="form" method="post" class="mt-16" action="/login" @submit="handleSubmit">
        <input type="hidden" name="ReturnUrl" :value="returnUrl">
        <input type="hidden" name="RememberMe" :value="form.rememberMe">
        
        <d-field label="Email">
          <d-input v-model="form.email" name="email" required type="email" />
        </d-field>
        
        <d-field label="Password">
          <d-input v-model="form.password" name="password" required type="password" />
        </d-field>

        <div v-if="showResendConfirmation" class="mb-4">
          <p v-if="noReplyEmail" class="mb-2">
            The verification email is sent from <strong>{{ noReplyEmail }}</strong>. Search your inbox and spam folder for that address if you cannot find it.
          </p>
          <d-btn type="button" :loading="resendingConfirmation" @click="resendConfirmation">
            Resend Verification Email
          </d-btn>
          <p v-if="confirmationMessage" class="mt-2">
            {{ confirmationMessage }}
          </p>
        </div>
        
        <div class="md:flex justify-between items-center mt-4 hidden">
          <a href="/forgotpassword/index">Forgot Password?</a>
          <a href="/promo">Login with Promo Code </a>

          <d-btn type="submit" :loading="submitting">
            Log In
          </d-btn>
        </div>
        <div class="md:hidden pt-5">
          <d-btn color="secondary-500" type="submit" :loading="submitting" block>
            Log In
          </d-btn>
          <div class="text-center pt-4">
            <a href="/forgotpassword/index">Forgot Password?</a>
          </div>
          <div class="text-center pt-4">
            <a href="/promo">Login with Promo Code </a>
          </div>
        </div>
        <hr class="my-10">
        <p class="text-center mb-5 text-xl">
          Are you looking to get started with {{orgSettings.applicationDisplayName}}?<br>Click the button below to sign up today.
        </p>
        <div class="justify-center md:flex hidden">
          <d-btn href="/register">
            Create an Account
          </d-btn>
        </div>
        <div class="md:hidden">
          <d-btn href="/register" size="sm" block>
            Create an Account
          </d-btn>
        </div>
      </form> 
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import localforage from '@resources/scripts/plugins/localstorage';

  export default {
    parent: true,

    props: {
      returnUrl: String,
      orgSettings: {
          type: Object,
          default: () => null,
      },
      pageErrors: {
        type: Array,
        default: () => [],
      },
    },

    data: (vm) => ({
      submitting: false,
      resendingConfirmation: false,
      genericError: '',
      confirmationMessage: '',
      showResendConfirmation: false,
      form: {
        email: '',
        password: '',
        rememberMe: true,
        returnUrl: vm.returnUrl,
      },
    }),

    mounted() {
      if (this.pageErrors.length > 0) {
        localforage.setItem('loginEmail', null);
        const error = this.getFirstPageError();
        this.genericError = error || 'Invalid username or password.';
        this.showResendConfirmation = this.genericError.toLowerCase().includes('confirm your email');
      }
      localforage.getItem('loginEmail')
        .then((value) => {
          this.form.email = value;
        });
    },

    computed: {
      noReplyEmail() {
        return this.orgSettings?.noReplyEmail || '';
      },
    },

    methods: {
      getFirstPageError() {
        for (const modelError of this.pageErrors) {
          const errors = modelError?.value?.errors || [];
          for (const error of errors) {
            if (error?.errorMessage) {
              return error.errorMessage;
            }
          }
        }
        return '';
      },
      async resendConfirmation() {
        if (!this.form.email) {
          this.confirmationMessage = 'Enter your email address above to resend the verification email.';
          return;
        }
        this.resendingConfirmation = true;
        try {
          const response = await axios.post('/api/user/register/resend-confirmation', { email: this.form.email });
          this.confirmationMessage = response.data.message;
        } catch {
          this.confirmationMessage = 'We were unable to resend your verification email. Please try again.';
        } finally {
          this.resendingConfirmation = false;
        }
      },
      handleSubmit(event) {
        this.submitting = true;
        localforage.setItem('loginEmail', this.form.email);
        // Let the form submit naturally to the server
        // The server will handle authentication and redirect/error handling
      },
    },
  };
</script>